export default "__VITE_ASSET__WQcOLFqV__"